<template>
    <div style="position: relative; height: 100%; width: 100%;">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
  </template>
  
  <script>
  import { Bar } from 'vue-chartjs'
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
  } from 'chart.js'
  
  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
  
  export default {
    name: 'SimpleBarChart',
    components: { Bar },
    props: {
      chartData: Object,
      chartOptions: Object
    }
  }
  </script>
  